import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { ErrorPageComponent } from './components/pages/error-page/error-page.component';
import { HomeDemoOneComponent } from './components/pages/home-demo-one/home-demo-one.component';
import { HomeDemoTwoComponent } from './components/pages/home-demo-two/home-demo-two.component';
import { HomeDemoThreeComponent } from './components/pages/home-demo-three/home-demo-three.component';
import { AboutPageComponent } from './components/pages/about-page/about-page.component';
import { ServicesPageComponent } from './components/pages/services-page/services-page.component';
import { ServiceDetailsPageComponent } from './components/pages/service-details-page/service-details-page.component';
import { TeamPageComponent } from './components/pages/team-page/team-page.component';
import { PricingPageComponent } from './components/pages/pricing-page/pricing-page.component';
import { InvestmentFundsPageComponent } from './components/pages/investment-funds-page/investment-funds-page.component';
import { HelpCenterPageComponent } from './components/pages/help-center-page/help-center-page.component';
import { SavingsInvestmentsPageComponent } from './components/pages/savings-investments-page/savings-investments-page.component';
import { BlogPageComponent } from './components/pages/blog-page/blog-page.component';
import { BlogDetailsPageComponent } from './components/pages/blog-details-page/blog-details-page.component';
import { BlogDetailsWithoutSidebarPageComponent } from './components/pages/blog-details-without-sidebar-page/blog-details-without-sidebar-page.component';
import { HomeLoanPageComponent } from './components/pages/home-loan-page/home-loan-page.component';
import { TestimonialsPageComponent } from './components/pages/testimonials-page/testimonials-page.component';
import { PrivacyPolicyPageComponent } from './components/pages/privacy-policy-page/privacy-policy-page.component';
import { TermsConditionsPageComponent } from './components/pages/terms-conditions-page/terms-conditions-page.component';
import { LoginPageComponent } from './components/pages/login-page/login-page.component';
import { RegisterPageComponent } from './components/pages/register-page/register-page.component';
import { HomeComponent } from './components/pages/home/home.component';
import { AuthGuard } from './core/auth/auth.guard';
import { RestartpassPageComponent } from './components/pages/restartpass-page/restartpass-page.component';
import { MsalRedirectComponent } from '@azure/msal-angular';



const routerOptions: ExtraOptions = {
    scrollPositionRestoration: 'enabled',
    anchorScrolling: 'enabled',
    scrollOffset: [0, 90],
    useHash: false
};


const routes: Routes = [
    { path: '', redirectTo: 'inicio', pathMatch: 'full' },
    { path: 'inicio', component: HomeComponent},
    { path: 'iniciar-sesion', component: LoginPageComponent },
    { path: 'restablecer-contrasena', component: RestartpassPageComponent },
    { path: 'registrarse', component: RegisterPageComponent },




    // { path: 'index-1', component: HomeDemoOneComponent },
    // { path: 'index-2', component: HomeDemoTwoComponent },
    // { path: 'index-3', component: HomeDemoThreeComponent },
    // { path: 'about', component: AboutPageComponent },
    // { path: 'services', component: ServicesPageComponent },
    // { path: 'service-details', component: ServiceDetailsPageComponent },
    // { path: 'team', component: TeamPageComponent },
    // { path: 'pricing', component: PricingPageComponent },
    // { path: 'testimonials', component: TestimonialsPageComponent },
    // { path: 'investment-funds', component: InvestmentFundsPageComponent },
    // { path: 'help-center', component: HelpCenterPageComponent },
    // { path: 'savings-investments', component: SavingsInvestmentsPageComponent },
    // { path: 'home-loan', component: HomeLoanPageComponent },
    // { path: 'blog', component: BlogPageComponent },
    // { path: 'blog-details', component: BlogDetailsPageComponent },
    // { path: 'blog-details-without-sidebar', component: BlogDetailsWithoutSidebarPageComponent },
    // { path: 'privacy-policy', component: PrivacyPolicyPageComponent },
    // { path: 'terms-conditions', component: TermsConditionsPageComponent },



    //{ path: 'chat-tasa', component: ChatTasaLayoutAssistanceComponent },




    { path: 'error', component: ErrorPageComponent },
    { path: 'auth-redirect', component: MsalRedirectComponent },
    { path: '**', redirectTo: 'error' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions)],
    exports: [RouterModule]
})
export class AppRoutingModule { }
